/**
 * @generated SignedSource<<99d516af8fe0e9f5d0ae288c53afc863>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PhotosSearchBrowsePhotoPreviewPhotoSwiper_photos$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly height: number | null;
      readonly id: string;
      readonly name: string | null;
      readonly path: string | null;
      readonly room: {
        readonly name: string | null;
      } | null;
      readonly serviceId: string | null;
      readonly styles: ReadonlyArray<{
        readonly name: string | null;
      } | null> | null;
      readonly url: string | null;
      readonly width: number | null;
    } | null;
  } | null> | null;
  readonly " $fragmentType": "PhotosSearchBrowsePhotoPreviewPhotoSwiper_photos";
};
export type PhotosSearchBrowsePhotoPreviewPhotoSwiper_photos$key = {
  readonly " $data"?: PhotosSearchBrowsePhotoPreviewPhotoSwiper_photos$data;
  readonly " $fragmentSpreads": FragmentRefs<"PhotosSearchBrowsePhotoPreviewPhotoSwiper_photos">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v1 = [
  (v0/*: any*/)
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PhotosSearchBrowsePhotoPreviewPhotoSwiper_photos",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PhotosSearchBrowseQueryEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PhotosSearchBrowsePhoto",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "serviceId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "path",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "url",
              "storageKey": null
            },
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "width",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "height",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "TradePhotoStyle",
              "kind": "LinkedField",
              "name": "styles",
              "plural": true,
              "selections": (v1/*: any*/),
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "TradePhotoStyle",
              "kind": "LinkedField",
              "name": "room",
              "plural": false,
              "selections": (v1/*: any*/),
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "PhotosSearchBrowseQueryConnection",
  "abstractKey": null
};
})();

(node as any).hash = "021f35a6060b7c1044587d659ae884e8";

export default node;
